var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMarker = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15C15.4477 15 15 14.5523 15 14C15 13.4477 15.4477 13 16 13C16.5523 13 17 13.4477 17 14C17 14.5523 16.5523 15 16 15ZM16 17C14.3431 17 13 15.6569 13 14C13 12.3431 14.3431 11 16 11C17.6569 11 19 12.3431 19 14C19 15.6569 17.6569 17 16 17Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1492 16.484C20.7626 15.3559 21 14.5478 21 14.0833C21 11.2535 18.7392 9 16 9C13.2608 9 11 11.2535 11 14.0833C11 14.5478 11.2374 15.3559 11.8508 16.484C12.434 17.5565 13.2362 18.7023 14.0761 19.7774C14.7514 20.642 15.4301 21.4341 16 22.0719C16.5699 21.4341 17.2486 20.642 17.9239 19.7774C18.7638 18.7023 19.566 17.5565 20.1492 16.484ZM17.3694 23.5404C19.4071 21.276 23 16.886 23 14.0833C23 10.1713 19.866 7 16 7C12.134 7 9 10.1713 9 14.0833C9 16.886 12.5929 21.276 14.6306 23.5404C15.4371 24.4367 16 25 16 25C16 25 16.5629 24.4367 17.3694 23.5404Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMarker, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/marker.a50e60f8.svg";
export { ForwardRef as ReactComponent };